import { render, staticRenderFns } from "./primary_inspection.vue?vue&type=template&id=262ec1f6&scoped=true&"
import script from "./primary_inspection.vue?vue&type=script&lang=js&"
export * from "./primary_inspection.vue?vue&type=script&lang=js&"
import style0 from "./primary_inspection.vue?vue&type=style&index=0&id=262ec1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262ec1f6",
  null
  
)

export default component.exports